module.exports = __webpack_public_path__ + "img/20200906_162314.fe8b9026.jpg";